import {Grid, IconButton, Typography} from '@mui/material';
import {EditIcon, MoreVerticalIcon} from 'lucide-react';
import {bindTrigger, usePopupState} from 'material-ui-popup-state/hooks';
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {
  CascadingMenu,
  MenuItem,
} from '../../../../components/CascadingMenu/CascadingMenu';

function ActionButtonMenuComp({popupId, onClick}) {
  const popupState = usePopupState({
    variant: 'popover',
    popupId,
  });

  return (
    <>
      <IconButton {...bindTrigger(popupState)}>
        <MoreVerticalIcon size={16} />
      </IconButton>
      <CascadingMenu
        popupState={popupState}
        anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
      >
        <Grid p={1}>
          <MenuItem
            onClick={() => {
              onClick();
              popupState.close();
            }}
          >
            <EditIcon size={16} />
            <Typography ml={1}>Reclassify</Typography>
          </MenuItem>
        </Grid>
      </CascadingMenu>
    </>
  );
}

ActionButtonMenuComp.propTypes = {
  popupId: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export const ActionButtonMenu = memo(ActionButtonMenuComp);
